import axios from 'axios';
import { HTTP_FORBIDDEN_CODE } from 'constants/constants';

// APIs to bypass 401 redirect
const bypassUrls = ['authenticate', 'qlik/token'];

const axiosQlikClient = () => {
  const defaultOptions = {
    baseURL: `${process.env.REACT_APP_API_HOST}/api/`,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Request interceptor
  instance.interceptors.request.use(
    function (config) {
      // In case of verify cookie API call, Authorization header is already set as Qlick token.
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${localStorage.getItem('c360-token')}`;
      }
      config.headers.qlikCookie = localStorage.getItem('qlikCookie');
      config.headers['q-token'] = localStorage.getItem('qlikToken');
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === HTTP_FORBIDDEN_CODE) {
        const url = error.config?.url || '';
        const shouldBypass = bypassUrls.some((bypassUrl) =>
          url.includes(bypassUrl)
        );

        if (!shouldBypass) {
          window.location.href = '/logout';
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default axiosQlikClient();
